const Resources = {

    table_headers: [
        { 
            text:     'Name',
            align:    'start',
            value:    'name',
            // type:     'link',
            event:    true,
        },
    ],

    task_table_headers: [
        { 
            name:   'Select',
        },
        { 
            name:   'Name',
        },
        { 
            name:   'Description',
        },
    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Options',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Floor Types',
            href:   '/options-floor-types',
            arrow:  "",
        },
    ],

    excel_file_headers: {
        'Name': 'name',
    },

    excel_file_headers_tasks:  
    {
        'Floor type': 'Floor type',
        'Task': 'Task'
    },

    empty_format_data_tasks: 
    [
        {
            'Floor type': '',
            'Task': '',
        }
    ],

    empty_format_data: [
        {
            name: '',
        },
    ]

}

export default Resources;